<template>
  <v-dialog v-model="dialogVisible" :max-width="maxWidth" persistent>
    <v-card class="dialog-card" dark>
      <v-card-title class="title-container" v-if="hasTitle">
        <div class="title-wrapper" style="min-height: 40px;">
          <slot name="title"></slot>
        </div>
        <v-btn outlined tile icon v-if="showCloseButton" @click="closeDialog" class="close-button">
          <v-icon>mdi mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <slot></slot>
      <v-card-actions v-if="$slots.actions">
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BasicDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: '800px'
    },
    isDark: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    hasTitle: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false;
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-card {
  background: rgba(114, 114, 102, 0.9) !important;

  .v-card__title {
    word-break: break-word;

    .title-content {
      word-break: break-word;
    }
  }

  .title-container {
    position: relative;
    padding-right: 52px; // Make space for the button
    word-break: break-word;
  }

  .title-wrapper {
    width: 100%;
  }

  .close-button {
    position: absolute;
    right: 16px;
    top: 12px;
  }


}

@media screen and (max-width: 960px) {
  .v-dialog > .v-card > .v-card__title {
    font-size: 1.35rem;
    line-height: 1.5rem;
  }
}
</style>
